import { Map } from 'immutable';
import actions from './action';

const initState = new Map({
  success: false,
  message: '',
  data: [],
});


export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.USER_ADD:
      return state
    // .set('success', action.success)
    // .set('msg', action.msg)
    // .set('data', action.data) 
    case actions.USER_API_SUCCESS:
      return state
        .set('data', action.data)
        .set('message', action.message)
        .set('success', action.success)
    case actions.USER_COMP_API_SUCCESS:
      return state
        .set('compdata', action.data)
        .set('message', action.message)
        .set('success', action.success)    
    case actions.USER_FETCH_LIST_ID:
      return state
        .set('success', action.success)
        .set('msg', action.msg)
        .set('data', action.data)
    case actions.CDD_BULK_UPDATE:
      return state
        .set('success', action.success)
        .set('msg', action.msg);
    default:
      return state;
  }
}
